export const INSTRUCTIONAL_SIDEBAR_KEYS = {
  idea: 'igideaidea',
  products: 'product',
  ceo: 'igceo',
  infrastructure: 'igaffiliation',
  business: 'vision_bmc',
  customers: 'igcustomers',
  startup: 'igpitch'
};

export const STANDARD_SECTIONS = [
  {
    name: 'create_startup',
    icon: 'fa fa-rocket',
    tourDir: 'right',
    borderTop: '1',
    tools: []
  },
  {
    name: 'gravitas',
    icon: 'fa fa-globe',
    tourDir: 'right',
    borderTop: '1',
    tools: []
  },
  {
    name: 'homer',
    icon: 'fa fa-home',
    tourDir: 'right',
    borderTop: '1',
    tools: []
  },
  {
    name: 'home',
    icon: 'fa fa-flask',
    tourDir: 'right',
    borderTop: '1',
    tools: []
  }
];

